export default __webpack_public_path__ + "static/media/icon-issues.c4f0de30.svg";